import React from 'react';
import PieChart from './PieChartComponent.js';

function getPartyColor(name) {

    if (name === 'PF') {
        return { color: 'green' };
    }
    else if (name === 'UPND') {
        return { color: 'red' }
    }
    else {
        return { color: '#000000' };
    }
}
function getPieData(data) {

  
    if (data) {
        return [
            { name: 'PF', value: data.pf },
            { name: 'UPND', value: data.upnd },
            { name: 'Others', value: data.other }
        ];
    } else {
        return null;
    }

}

function getTitle(data, id) {


    if (data) {
        return data.name;
    } else {
        return id;
    }
}

function getProjectedWinner(data) {

  
    if (data) {

        if (data.pf / data.registered > 0.3) {

            return 'PF';
        }
        else if (data.upnd / data.registered > 0.3) {
            return 'UPND';
        }
        else {
            return 'Non-conclusive';
        }
    } else {
        return 'No Data Availbale';
    }
}
export default function TooltipTemplate(info) {
    const data = info.attribute('data');
    const id = info.attribute('fid');
    const pieData = getPieData(data);

    const graphic = pieData ?
        <PieChart data={pieData}></PieChart> :
        <div>No election data availbale</div>;

    const projectedWinner = getProjectedWinner(data);
    const textStyle = getPartyColor(projectedWinner);
    const name = getTitle(data, info.attribute('fid'));

    return (
        <div>
            <h4>2016 Elections</h4>
            <h5>{name}</h5>
            {graphic}
            <h4>2021 Elections</h4>
            <h5>Projected Winner for {name}: <span style={textStyle}>{projectedWinner}</span></h5>
            <p>Disclaimer: The projected winner for 2021 is automatically<br/> calculated based on votting patterns in previous elections<br/>  for that constituency</p>

        </div>
    );
}
